module.exports = __webpack_public_path__ + "static/img/JF_H5.6a64a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/JF_H5.png
// module id = gA6o
// module chunks = 34